import React from 'react'

export default function Skill({project,removeProject,id}) {
	return (
		<>
			<li className="details-list-item"><h3><strong>{project.title}</strong></h3>
				{removeProject && (<span className="close-icon"><button onClick={()=>removeProject(id)}><i class="far fa-trash-alt"></i></button></span>)}
				<div>
					<p>{project.desc}</p>
					<span className="link-style">{project.reference}</span>
				</div>
			</li>
		</>
	)
}